(function () {
  function norm(v) {
    return String(v ?? "").trim().replace(/["'″”“]/g, "").trim();
  }

  function getProductSelectorFromEventTarget(t) {
    return t && t.closest ? t.closest("product-selector") : null;
  }

  function getVariants(ps) {
    const json = ps.querySelector('[type="application/json"]');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch { return null; }
  }

  function getSelectedValues(ps) {
    // group radios by name in DOM order
    const radios = Array.from(ps.querySelectorAll('input[type="radio"]'));
    const names = [];
    for (const r of radios) {
      if (r.name && !names.includes(r.name)) names.push(r.name);
    }
    const vals = names.map(name => {
      const checked = ps.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`);
      return checked ? checked.value : null;
    });

    // fallback: selects
    if (!vals.length || vals.every(v => v == null)) {
      const selects = Array.from(ps.querySelectorAll("select"));
      if (selects.length) return selects.map(s => s.value);
    }

    return vals;
  }

  function findVariant(variants, selected) {
    if (!variants || !variants.length) return null;

    // exact match on v.options
    let m = variants.find(v => Array.isArray(v.options) && v.options.every((opt, i) => opt === selected[i]));
    if (m) return m;

    // normalized match
    m = variants.find(v => Array.isArray(v.options) && v.options.every((opt, i) => norm(opt) === norm(selected[i])));
    if (m) return m;

    // fallback option1/2/3
    m = variants.find(v => {
      if (selected.length > 0 && norm(v.option1) !== norm(selected[0])) return false;
      if (selected.length > 1 && norm(v.option2) !== norm(selected[1])) return false;
      if (selected.length > 2 && norm(v.option3) !== norm(selected[2])) return false;
      return true;
    });

    return m || variants[0];
  }

  function formatMoneyLikePage(cents, priceRoot) {
    const existing =
      priceRoot?.querySelector('.price_regular span:not(.visually-hidden)') ||
      priceRoot?.querySelector('.price__regular span:not(.visually-hidden)') ||
      priceRoot?.querySelector('ins') ||
      priceRoot?.querySelector('span');

    const text = existing?.textContent?.trim() || "";
    const wantsCode = /[A-Z]{3}$/.test(text);

    const moneyFormat =
      (wantsCode && (window.theme?.money_with_currency_format || window.Shopify?.money_with_currency_format)) ||
      (!wantsCode && (window.theme?.money_format || window.Shopify?.money_format)) ||
      '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    const n = cents / 100;
    return wantsCode
      ? `${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`
      : n.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function apply(ps) {
    const variants = getVariants(ps);
    if (!variants) return;

    const selected = getSelectedValues(ps);
    const v = findVariant(variants, selected);
    if (!v) return;

    // 1) URL
    const params = new URLSearchParams(window.location.search);
    params.set("variant", v.id);
    window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);

    // 2) hidden variant input
    const idInput =
      ps.querySelector('[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) idInput.value = v.id;

    // 3) price text (supports .price_regular and .price__regular)
    const sectionId = ps.dataset.sectionId;
    const priceRoot =
      (sectionId && document.querySelector(`#Product-Price-${sectionId}`)) ||
      document.querySelector('[id^="Product-Price-"]') ||
      document.querySelector('.product__price') ||
      null;

    if (priceRoot) {
      const target =
        priceRoot.querySelector('.price_regular span:not(.visually-hidden)') ||
        priceRoot.querySelector('.price__regular span:not(.visually-hidden)') ||
        priceRoot.querySelector('.price__sale ins') ||
        priceRoot.querySelector('ins') ||
        priceRoot.querySelector('span');

      if (target) target.textContent = formatMoneyLikePage(v.price, priceRoot);
    }
  }

  // Delegated click handler:
  // - Works even if the theme replaces <product-selector> after the first change
  // - Also forces radios to actually check when clicking option tiles
  document.addEventListener("click", (e) => {
    const ps = getProductSelectorFromEventTarget(e.target);
    if (!ps) return;

    // If click happened on an option tile, force-check its radio (common theme bug)
    const optionItem = e.target.closest(".product-options__item");
    if (optionItem && ps.contains(optionItem)) {
      const radio = optionItem.querySelector('input[type="radio"]');
      if (radio && !radio.disabled && !radio.checked) {
        // uncheck siblings in the same group
        if (radio.name) {
          ps.querySelectorAll(`input[type="radio"][name="${CSS.escape(radio.name)}"]`).forEach(r => (r.checked = false));
        }
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        return; // change handler will call apply()
      }
    }

    // After click, let browser/theme update state, then apply
    setTimeout(() => apply(ps), 0);
  }, true);

  // Delegated change handler (for radios/selects)
  document.addEventListener("change", (e) => {
    const ps = getProductSelectorFromEventTarget(e.target);
    if (!ps) return;
    apply(ps);
  }, true);

  // Initial pass (in case page loads with a variant selected)
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-selector").forEach(ps => apply(ps));
  });
})();
